package one.healthium.log_period.domain

enum class PeriodPhase {
    UNDEFINED,
    NORMAL_CYCLE,
    DELAYED_CYCLE,
    EARLY_CYCLE,
}


